import { render, staticRenderFns } from "./PrivacyContent.vue?vue&type=template&id=27ea48b2&scoped=true"
import script from "./PrivacyContent.vue?vue&type=script&lang=js"
export * from "./PrivacyContent.vue?vue&type=script&lang=js"
import style0 from "./PrivacyContent.vue?vue&type=style&index=0&id=27ea48b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27ea48b2",
  null
  
)

export default component.exports